import CommunicationProgramContainer from './CommunicationProgramContainer.js';

export default CommunicationProgramContainer;